module.exports = __webpack_public_path__ + "img/signedCircleRestriction.182f5e6f.svg";